import { FC } from 'react';
import styles from './Breadcrumbs.module.scss';
import Link from 'next/link';

interface IBreadcrumbs {
  pageName: string;
  pageAlias?: string;
  dynamicPageEmoji?: string;
  dynamicPageName?: string;
  isBottom?: boolean;
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ pageName, pageAlias, dynamicPageEmoji, dynamicPageName, isBottom }) => {
  return (
    <div className={`${styles.breadcrumbsListWrap} ${isBottom ? styles.breadcrumbsListWrap_bottom : ``}`}>
      <ul className={styles.breadcrumbsList}>
        <li className={styles.breadcrumbsList__item}>
          <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href="/">
            Главная
          </Link>
        </li>
        <li className={styles.breadcrumbsList__item}>
          {!!pageAlias ? (
            <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`${pageAlias}`}>
              {pageName}
            </Link>
          ) : (
            <>{pageName}</>
          )}
        </li>
        {!!dynamicPageName && (
          <li className={styles.breadcrumbsList__item}>
            {dynamicPageEmoji}
            <span className={styles.breadcrumbsList__itemTxt}>{dynamicPageName}</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
